/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import RecordingLabel from '../../../recording/components/web/RecordingLabel';
import { isToolboxVisible } from '../../../toolbox/functions.web';
import { getConferenceInfo } from '../functions.web';
import ConferenceInfoContainer from './ConferenceInfoContainer';
import ParticipantsRecordingLabel from "../../../recording/components/web/ParticipantsRecordingLabel";
const COMPONENTS = [
    {
        Component: () => (React.createElement(React.Fragment, null,
            React.createElement(ParticipantsRecordingLabel, null),
            React.createElement(RecordingLabel, { mode: JitsiRecordingConstants.mode.FILE }),
            React.createElement(RecordingLabel, { mode: JitsiRecordingConstants.mode.STREAM }))),
        id: 'recording'
    }
];
/**
 * The upper band of the meeing containing the conference name, timer and labels.
 *
 * @param {Object} props - The props of the component.
 * @returns {React$None}
 */
class ConferenceInfo extends Component {
    /**
     * Initializes a new {@code ConferenceInfo} instance.
     *
     * @param {IProps} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._renderAutoHide = this._renderAutoHide.bind(this);
        this._renderAlwaysVisible = this._renderAlwaysVisible.bind(this);
    }
    /**
     * Renders auto-hidden info header labels.
     *
     * @returns {void}
     */
    _renderAutoHide() {
        const { autoHide } = this.props._conferenceInfo;
        if (!autoHide?.length) {
            return null;
        }
        return (React.createElement(ConferenceInfoContainer, { id: 'autoHide', visible: this.props._visible }, COMPONENTS
            .filter(comp => autoHide.includes(comp.id))
            .map(c => React.createElement(c.Component, { key: c.id }))));
    }
    /**
     * Renders the always visible info header labels.
     *
     * @returns {void}
     */
    _renderAlwaysVisible() {
        const { alwaysVisible } = this.props._conferenceInfo;
        if (!alwaysVisible?.length) {
            return null;
        }
        return (React.createElement(ConferenceInfoContainer, { id: 'alwaysVisible', visible: true }, COMPONENTS
            .filter(comp => alwaysVisible.includes(comp.id))
            .map(c => React.createElement(c.Component, { key: c.id }))));
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", { className: `details-container ${this.props._visible ? 'visible' : ''}` },
            React.createElement("div", { style: { display: 'flex', paddingLeft: '16px' } },
                this._renderAlwaysVisible(),
                this._renderAutoHide())));
    }
}
/**
 * Maps (parts of) the Redux state to the associated
 * {@code Subject}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _visible: boolean,
 *     _conferenceInfo: Object
 * }}
 */
function _mapStateToProps(state) {
    const { is_in_picture_in_picture_mode } = state['features/picture-in-picture'];
    return {
        _visible: isToolboxVisible(state) && !is_in_picture_in_picture_mode,
        _conferenceInfo: getConferenceInfo(state)
    };
}
export default connect(_mapStateToProps)(ConferenceInfo);
